import { Container } from '@material-ui/core';
import { green, purple } from '@material-ui/core/colors';
import { React, useEffect, useState } from 'react';
import * as API from '../../api/index';
import Mpesa from '../../payments/mpesa/mpesa';
import ReactPaypal from '../../payments/paypal/paypal';
import { PaymentBoxHeader, PaymentTitle, StyledBox, StyledGamesBox, StyledHeading, StyledParagraph, StyledPaymentBox, StyledPaymentPaper, StyledSection } from '../styles/global-style';
import JackpotTable from './jackpottable';



const BongoBongo = () => {
    const [games, setGames] = useState([]);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    const [subscribed, setSubscribed] = useState(false);


    useEffect(() => {
        getGames();
        getUser();
        document.title = 'BongoBongo Jackpot'
    }, [])

    const getGames = async () => {
        try {
            const { data } = await API.jackpotGames('BG')
            const match = data[0].games
            setGames(match)

        } catch (error) {
            console.log(error);
        }
    }

    const getUser = async () => {
        try {
            const username = user?.user.username
            const { data } = await API.bongobongoSubscribers(username)
            setSubscribed(data[0].bongobongo)

        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Container align='center'>
            <StyledBox align='justify'>
                <StyledHeading variant='h5'>BongoBongo Jackpot Prediction</StyledHeading>

                <StyledParagraph variant='caption'>
                    Below are <b>BongoBongo jackpot games</b> in conjuction with <b>free predictions</b> for the first 5 matches.
                </StyledParagraph>
            </StyledBox>
            <StyledSection>
                <StyledGamesBox>
                    <JackpotTable subscribed={subscribed} games={games} />
                </StyledGamesBox>
                <StyledPaymentPaper>
                    <StyledPaymentBox >
                        <PaymentBoxHeader variant='h5'>Book Now</PaymentBoxHeader>
                        <PaymentTitle mleft={10} textcolor={green[900]}>Pay with Mpesa</PaymentTitle>
                        <Mpesa price={300} product={'bongobongo'} />
                        <PaymentTitle mleft={10} textcolor={purple[900]}>Pay with PayPal</PaymentTitle>
                        <ReactPaypal price={3.0} product={'bongobongo'} />
                    </StyledPaymentBox>
                </StyledPaymentPaper>
            </StyledSection>

            <StyledBox mt={5} align='justify'>
                <StyledParagraph variant='caption'>
                    To access complete predictions for this Jackpot simply subscribe by making a payment of <b>$3 or Ksh. 300</b>.
                    <b>Alternatively,</b> you can join <b>VIP</b> which comes in hand with a free jackpot prediction of your choice. Happy Betting.
                </StyledParagraph>
            </StyledBox>
        </Container>
    );
};

export default BongoBongo;
